import { onBeforeUnmount, onMounted, ref } from 'vue';

import { prefersReducedMotion } from '@/utils/motion';

export function useInView(threshold = 0.6) {
  const target = ref(null);
  const inView = ref(false);
  let observer;

  onMounted(() => {
    if (prefersReducedMotion()) {
      inView.value = true; // Skip the entrance and show the final state.
      return;
    }
    observer = new IntersectionObserver(
      ([entry], obs) => {
        if (!entry.isIntersecting) return;
        inView.value = true;
        obs.disconnect();
      },
      { threshold },
    );
    observer.observe(target.value);
  });
  onBeforeUnmount(() => observer?.disconnect());

  return { target, inView };
}
